import { MruCache } from 'owa-mru-cache';
import type ClientItem from './schema/ClientItem';
import shouldReduceMemoryForDevice from '../utils/shouldReduceMemoryForDevice';

export type MessageMruCache = MruCache<ClientItem>;

let messageCache: MessageMruCache | null = null;

export default function getMessageCache(): MessageMruCache {
    if (messageCache == null) {
        const cacheSize = shouldReduceMemoryForDevice() ? 10 : 50;
        messageCache = new MruCache<ClientItem>('Messages', cacheSize);
    }
    return messageCache;
}
